import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { House, ListChecks, CalendarCheck } from '@phosphor-icons/react';
import { Banner } from '@astryxdesign/core/Banner';
import { useAccent } from '@/app/providers';
import { AppFrame } from '@/components/AppFrame';
import { BottomNav } from '@/components/BottomNav';
import { ErrorView, PageLoader, SetupRequired } from '@/components/StateViews';
import { envError } from '@/lib/env';
import { registerTenantWorker } from '@/lib/pwa';
import { savedBookings } from '@/lib/store';
import { BookingSheet } from './BookingSheet';
import { useSlug, useTenant } from './hooks';

export function PublicLayout() {
  if (envError) return <SetupRequired message={envError} />;
  return <TenantShell />;
}

function TenantShell() {
  const slug = useSlug();
  const tenant = useTenant();
  const { setAccent } = useAccent();

  useEffect(() => {
    setAccent(tenant.data?.profile.accent);
    if (tenant.data) document.title = `${tenant.data.name} — онлайн-запись`;
  }, [tenant.data, setAccent]);

  useEffect(() => {
    void registerTenantWorker(slug);
  }, [slug]);

  if (tenant.isPending) return <PageLoader />;
  if (tenant.isError) return <ErrorView error={tenant.error} onRetry={() => void tenant.refetch()} />;

  const base = `/s/${slug}`;
  const myCount = savedBookings(slug).length;

  return (
    <AppFrame
      overlay={<BookingSheet />}
      nav={
        <BottomNav
          label="Разделы студии"
          items={[
            { to: base, label: 'Главная', icon: House, end: true },
            { to: `${base}/services`, label: 'Услуги', icon: ListChecks },
            { to: `${base}/my`, label: 'Моя запись', icon: CalendarCheck, badge: myCount || undefined },
          ]}
        />
      }
    >
      {tenant.data.status === 'preview' ? (
        <Banner
          status="info"
          container="section"
          title="Демо-режим"
          description="Студия настраивает онлайн-запись. Записи сейчас тестовые, уведомления не отправляются."
        />
      ) : null}
      <main>
        <Outlet />
      </main>
    </AppFrame>
  );
}
